<template>
  <Teleport to="body">
    <Transition name="sh-fade">
      <div v-if="open" class="sh-overlay" @mousedown.self="close">
        <div class="sh-box" role="dialog" aria-label="Atalhos de teclado">

          <div class="sh-header">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="2" y="7" width="20" height="14" rx="2" ry="2"/>
              <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/>
            </svg>
            Atalhos de Teclado
            <button class="sh-close" @click="close">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round">
                <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
              </svg>
            </button>
          </div>

          <div class="sh-body">
            <div class="sh-section">
              <div class="sh-section-title">Geral</div>
              <div class="sh-row">
                <div class="sh-keys"><kbd>/</kbd></div>
                <div class="sh-desc">Abrir busca global</div>
              </div>
              <div class="sh-row">
                <div class="sh-keys"><kbd>Ctrl</kbd><span class="sh-plus">+</span><kbd>K</kbd></div>
                <div class="sh-desc">Abrir busca global</div>
              </div>
              <div class="sh-row">
                <div class="sh-keys"><kbd>?</kbd></div>
                <div class="sh-desc">Ver atalhos</div>
              </div>
              <div class="sh-row">
                <div class="sh-keys"><kbd>Esc</kbd></div>
                <div class="sh-desc">Fechar janela ativa</div>
              </div>
              <div class="sh-row">
                <div class="sh-keys"><kbd>K</kbd></div>
                <div class="sh-desc">Enviar aviso para agentes</div>
                <span class="sh-status" :class="broadcastEnabled ? 'sh-status--on' : 'sh-status--off'">
                  {{ broadcastEnabled ? 'Habilitado' : 'Desabilitado' }}
                </span>
              </div>
            </div>

            <div class="sh-divider"></div>

            <div class="sh-section">
              <div class="sh-section-title">Conversas</div>
              <div class="sh-row">
                <div class="sh-keys"><kbd>N</kbd></div>
                <div class="sh-desc">Próxima conversa na lista</div>
              </div>
              <div class="sh-row">
                <div class="sh-keys"><kbd>P</kbd></div>
                <div class="sh-desc">Conversa anterior na lista</div>
              </div>
              <div class="sh-row">
                <div class="sh-keys"><kbd>R</kbd></div>
                <div class="sh-desc">Focar campo de resposta</div>
              </div>
              <div class="sh-row">
                <div class="sh-keys"><kbd>C</kbd></div>
                <div class="sh-desc">Abrir minhas conversas</div>
              </div>
              <div class="sh-row">
                <div class="sh-keys"><kbd>M</kbd></div>
                <div class="sh-desc">Abrir Modo Foco</div>
              </div>
              <div class="sh-row">
                <div class="sh-keys"><kbd>Ctrl</kbd><span class="sh-plus">+</span><kbd>↵</kbd></div>
                <div class="sh-desc">Enviar mensagem</div>
              </div>
            </div>

            <div class="sh-divider"></div>

            <div class="sh-section">
              <div class="sh-section-title">Navegação</div>
              <div class="sh-row">
                <div class="sh-keys"><kbd>↑</kbd><kbd>↓</kbd></div>
                <div class="sh-desc">Navegar nos resultados da busca</div>
              </div>
              <div class="sh-row">
                <div class="sh-keys"><kbd>↵</kbd></div>
                <div class="sh-desc">Abrir item selecionado na busca</div>
              </div>
            </div>
          </div>

          <div class="sh-footer">
            Pressione <kbd>?</kbd> a qualquer momento para ver esta tela
          </div>

        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { shortcutsHelpOpen, closeShortcutsHelp } from '@/composables/useShortcutsHelp'
import { useAdmin } from '@/composables/useAdmin'

const open  = shortcutsHelpOpen
const { globalSettings } = useAdmin()
// Reflete a chave "Envio de Aviso Interno" de Configurações Gerais (kill-switch
// geral, independente de perfil) — não a permissão broadcast.send em si, que
// segue controlando se o atalho de fato funciona pra este usuário.
const broadcastEnabled = computed(() => globalSettings.value.broadcastEnabled)
function close() { closeShortcutsHelp() }
</script>

<style scoped>
.sh-overlay {
  position: fixed;
  inset: 0;
  z-index: 9100;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
}

.sh-box {
  width: 100%;
  max-width: 420px;
  background: #1a2332;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.5);
}

.sh-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.07);
  font-size: 14px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.85);
}

.sh-close {
  margin-left: auto;
  background: none;
  border: none;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.4);
  display: flex;
  align-items: center;
  padding: 4px;
  border-radius: 6px;
  transition: color 0.15s, background 0.15s;
}

.sh-close:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.08);
}

.sh-body {
  padding: 8px 0;
}

.sh-section {
  padding: 8px 20px;
}

.sh-section-title {
  font-size: 10.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: rgba(255, 255, 255, 0.28);
  margin-bottom: 6px;
  margin-top: 4px;
}

.sh-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 5px 0;
}

.sh-keys {
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 110px;
  flex-shrink: 0;
}

.sh-keys kbd {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-bottom-width: 2px;
  border-radius: 5px;
  padding: 2px 8px;
  font-family: inherit;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.75);
  white-space: nowrap;
  line-height: 1.5;
}

.sh-plus {
  color: rgba(255, 255, 255, 0.3);
  font-size: 11px;
}

.sh-desc {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.55);
  flex: 1;
}

.sh-status {
  font-size: 10.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .03em;
  padding: 2px 8px;
  border-radius: 99px;
  flex-shrink: 0;
  white-space: nowrap;
}
.sh-status--on  { background: rgba(34,197,94,.15); color: #4ade80; }
.sh-status--off { background: rgba(239,68,68,.15); color: #f87171; }

.sh-divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.06);
  margin: 4px 0;
}

.sh-footer {
  padding: 12px 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.07);
  font-size: 12px;
  color: rgba(255, 255, 255, 0.25);
  text-align: center;
}

.sh-footer kbd {
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  padding: 1px 5px;
  font-family: inherit;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.4);
}

.sh-fade-enter-active,
.sh-fade-leave-active {
  transition: opacity 0.15s ease;
}
.sh-fade-enter-active .sh-box,
.sh-fade-leave-active .sh-box {
  transition: transform 0.15s ease, opacity 0.15s ease;
}
.sh-fade-enter-from,
.sh-fade-leave-to { opacity: 0; }
.sh-fade-enter-from .sh-box,
.sh-fade-leave-to .sh-box { transform: scale(0.96); opacity: 0; }
</style>
